import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UsersAuthService } from '../users-auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    /* **** 2025-10-08 JBDCR: Error codes treated as authentication/expiration errors */
    private readonly AUTH_ERROR_CODES = new Set([401]);

    constructor(private sessionService: UsersAuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Don't block assets or the login endpoint
        const url = req.url || '';
        const isAsset =
            url.endsWith('.css') ||
            url.endsWith('.js') ||
            url.endsWith('.png') ||
            url.endsWith('.jpg') ||
            url.endsWith('.jpeg') ||
            url.endsWith('.svg') ||
            url.endsWith('.ico') ||
            url.endsWith('.woff') ||
            url.endsWith('.woff2') ||
            url.endsWith('.ttf');

        //const isApiLogin = url.indexOf('/api/UserAuth/LogIN') >= 0;
        const isSpaLogin = url.indexOf('/pages/login') >= 0;
        const isSpaRecovery = url.indexOf('/pages/recovery') >= 0;
        const isSpaForgot = url.indexOf('/pages/forgotpassword') >= 0;
        const isSpaRegister = url.indexOf('/pages/register') >= 0;

        let outgoingReq = req;

        // **** 2025-10-10 JBDCR: Don't modify original headers.
        // We only add headers if:
        //  - it's not an asset or login,
        //  - there is a session,
        //  - and the specific header is NOT already present in the request.
        if (!isAsset && !isSpaLogin && !isSpaForgot && !isSpaRecovery && !isSpaRegister && this.sessionService.isAuthenticated()) {
            const s = this.sessionService.getSession();
            const token = s && s.Token ? s.Token : '';
            const roleId = (s && s.RoleID != null) ? String(s.RoleID) : null;

            const setMap: { [k: string]: string } = {};

            // If the consumer has already set 'Authorization' in the request, we respect it
            if (!req.headers.has('Authorization')) {
                setMap['Authorization'] = 'true';
            }
            // Add Token only if it doesn't exist and we have a valid one
            if (!req.headers.has('Token') && token) {
                setMap['Token'] = token;
            }
            // Add RoleID only if it doesn't exist and we have one
            if (roleId && !req.headers.has('RoleID')) {
                setMap['RoleID'] = roleId;
            }

            // If there's anything to add, we clone; if not, we leave the request intact
            if (Object.keys(setMap).length > 0) {
                outgoingReq = req.clone({
                    setHeaders: setMap
                    // Important: NO touch headers are made here to avoid changing the original behavior
                });
            }
        }

        return next.handle(outgoingReq).pipe(
            catchError((err: any) => {
                if (err instanceof HttpErrorResponse) {
                    // Auth errors (authentication/expiration) -> redirect and cut propagation
                    if (this.AUTH_ERROR_CODES.has(err.status)) {
                        this.sessionService.redirectToLoginWithExpiredFlag();
                        // **** 2025-10-08 JBDCR: Avoid showing swals in login
                        return EMPTY; // do not propagate the error
                    }
                }
                // Other errors: propagate normally
                return throwError(err);
            })
        );
    }
}
